import React from "react";
import { Button, Col, Form, Row, Input, Checkbox, Select } from "antd";
import { GUTTER_MD,
         MARGIN_MD,
         SPAN_FULL,
         MARGIN_SM,
         MODAL_WIDTH_SM,
         SPAN_HALF
} from "../../styles/constants";
import EnhancedModal from "../../components/enhanced-modal";
import { compose } from "redux";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { hideArtefactFullExport, changeArtefactFullExport, artefactFullExport } from "./actions";
import _ from "lodash";
import { getLanguageFlagIconCss, getLanguageLabel } from "../../utils/languages";

const formItemLayout = {
  labelCol: {span: SPAN_HALF},
  wrapperCol: {span: SPAN_HALF}
};

const mapStateToProps = (state) => ({
    downloadForm: state.scenes.metaManager.artefactFullExport.downloadForm,
    artefactsData: state.scenes.metaManager.artefactFullExport.artefactsData,
    columnsMap: state.scenes.metaManager.artefactFullExport.columnsMap,
    isVisible: state.scenes.metaManager.artefactFullExport.isVisible,
    dataLanguages: state.config.dataManagement.dataLanguages
});

const mapDispatchToProps = (dispatch) => ({
  onSubmit: (artefacts, separator, delimiter, isCompressed, lang, columnsMap, path) => dispatch(artefactFullExport(artefacts, separator, delimiter, isCompressed, lang, columnsMap, path)),
  onChange: (fields) => dispatch(changeArtefactFullExport(fields)),
  onHide: () => dispatch(hideArtefactFullExport()),
});

const mapPropsToFields = ({ downloadForm }) => ({
  separator: Form.createFormField({ value: downloadForm ? downloadForm.separator : null }),
  delimiter: Form.createFormField({ value: downloadForm ? downloadForm.delimiter : null }),
  isCompressed: Form.createFormField({ value: downloadForm ? downloadForm.isCompressed : null }),
  lang: Form.createFormField({ value: downloadForm ? downloadForm.lang : 'en' })
});

const onFieldsChange = (props, fields) => props.onChange(_.mapValues(fields, ({value}) => value));

const ArtefactFullExportForm = ({
  t,
  form,
  isVisible,
  downloadForm,
  artefactsData,
  onHide,
  onSubmit,
  dataLanguages,
  columnsMap
}) => {
  return (
    <EnhancedModal
      visible={isVisible}
      onCancel={() => onHide()}
      title={artefactsData !== null && artefactsData !== undefined && artefactsData.length === 1 ? 
        t('scenes.metaManager.commons.modals.export.title', {
            triplet: artefactsData[0].id
          })
        : t('scenes.metaManager.commons.modals.export.titleMulti')
    }
      width={MODAL_WIDTH_SM}
      footer={
        <div>
            <Button onClick={() => onHide()}>
              {t("commons.buttons.close.title")}
            </Button>
            <Button
              disabled={downloadForm ? (downloadForm.separator === null || downloadForm.separator === '' || !downloadForm.lang) : true}
              icon="export"
              type="primary"
              onClick={() => onSubmit(
                artefactsData,
                downloadForm.separator,
                downloadForm.delimiter,
                downloadForm.isCompressed,
                downloadForm.lang,
                columnsMap,
                window.location.hash
              )}
            >
              {t('commons.buttons.export.title')}
            </Button>
        </div>
      }
    >
      <Form className="advanced-form">
      <Row style={{marginTop: MARGIN_MD}}>
          <Col span={SPAN_FULL}>
            <Form.Item
              className="form-item-required"
              label={t('data.csv.language.label')}
              {...formItemLayout}
            >
              {form.getFieldDecorator('lang')(
                <Select
                  showSearch
                  filterOption={(inputValue, { props }) =>
                    props.title.toLowerCase().includes(inputValue.toLowerCase())
                  }
                  title={form.getFieldValue("lang")}
                >
                  {dataLanguages.map(
                    ({ code }) =>
                      <Select.Option key={code} value={code} title={getLanguageLabel(t, code)}>
                        <i
                          className={`flag-icon ${getLanguageFlagIconCss(code, dataLanguages)}`}
                          style={{ marginRight: 8 }}
                        />
                        {getLanguageLabel(t, code)}
                      </Select.Option>
                  )}
                </Select>
              )}
            </Form.Item>
          </Col>
        </Row>
        <Row style={{marginTop: MARGIN_MD}}>
          <Col span={SPAN_FULL}>
            <Form.Item
              className="form-item-required"
              label={t('data.csv.separator.label')}
              {...formItemLayout}
            >
              {form.getFieldDecorator('separator')(
                <Input  
                    onKeyPress={(event) => {
                      if (!/[^-|:]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    maxLength={1}
                    title={form.getFieldValue('separator')}
                />
              )}
            </Form.Item>
          </Col>
        </Row>
        <Row style={{marginTop: MARGIN_MD}}>
          <Col span={SPAN_FULL}>
            <Form.Item
              className="form-item"
              label={t('data.csv.delimiter.label')}
              {...formItemLayout}
            >
              {form.getFieldDecorator('delimiter')(
                <Input 
                    onKeyPress={(event) => {
                      if (!/[^-|:]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    maxLength={1}
                    title={form.getFieldValue('delimiter')}
                />
              )}
            </Form.Item>
          </Col>
        </Row>
        <Row style={{marginTop: MARGIN_MD}}>
          <Col span={SPAN_FULL}>
            <Form.Item
              className="form-item"
              label={t('components.artefactDownloadForm.compression.label')}
              {...formItemLayout}
            >
                {form.getFieldDecorator('isCompressed')(
                  <Checkbox
                    title={form.getFieldValue('isCompressed')}
                  />
                )}
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </EnhancedModal>
  );
};

export default compose(
  translate(),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  Form.create({ mapPropsToFields, onFieldsChange })
)(ArtefactFullExportForm);
